module.exports = __webpack_public_path__ + "img/干线派车.f07ca62f.svg";